// extracted by mini-css-extract-plugin
export default {"header":"Navbar_header__G8Zkc","logo":"Navbar_logo__aYTap","links":"Navbar_links__3YadE"};